<template>
  <div id="app" v-cloak>
    <!-- 路由入口 -->
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'App',
  components: {
    headTop:resolve => {require(['@/components/head.vue'],resolve)},//头部
    foot:resolve => {require(['@/components/foot.vue'],resolve)},//底部
    // home:resolve => {require(['@/view/home/home.vue'],resolve)}//首页
  }
}
</script>
<style>
#app {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  cursor: default;
}
[v-cloak] {
  display:none;
}

</style>





// WEBPACK FOOTER //
// src/App.vue